import { fgFilterEntries } from "@redotech/redo-fulfillment-operations-common/views/fulfillment/fg-filter-catalog";
import { WeightFormat } from "@redotech/redo-fulfillment-outbound-labels-common/outbound-label-enums";
import BoxIcon from "@redotech/redo-icons/box-01.svg";
import { NumberFilterOperator } from "@redotech/redo-views-common/advanced-filters/number-filter";
import { AdvancedTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

const entry = fgFilterEntries.parcelWeight;

export const WeightFilter = (format: WeightFormat): AdvancedTableFilter => {
  if (format === WeightFormat.METRIC) {
    return {
      type: entry.type,
      min: 0,
      suffix: "kg",
      modifier: 1,
      data: {
        modifier: 1,
        name: entry.name,
        type: entry.type,
        value: null,
        operator: NumberFilterOperator.GREATER_THAN,
      },
      step: 1,
      secondField: { scalar: 1000, min: 0, max: 999, suffix: "g", step: 1 },
      Icon: BoxIcon,
      displayName: entry.displayName,
    };
  }
  return {
    type: entry.type,
    min: 0,
    suffix: "lb",
    modifier: 28.3495,
    data: {
      modifier: 28.3495,
      name: entry.name,
      type: entry.type,
      value: null,
      operator: NumberFilterOperator.GREATER_THAN,
    },
    step: 1,
    secondField: { scalar: 16, min: 0, max: 15, suffix: "oz", step: 1 },
    Icon: BoxIcon,
    displayName: entry.displayName,
  };
};
